import React, { useState } from "react";

type CheckboxProps = {
    id: string,
    onChange: any,
    initialState?: boolean
}

const Checkbox = ({ id, onChange, initialState = false }: CheckboxProps) => {
    const [checked, setChecked] = useState(initialState);

    const unCheckedClassName = "checkbox";
    const checkedClassName = `${unCheckedClassName} icon-tick`;

    const change = () => {
        const isChecked = !checked;
        setChecked(isChecked);
        onChange(isChecked);
    }

    return (
        <span>
            <i id={id} className={checked ? checkedClassName : unCheckedClassName} onClick={change}></i>
        </span>
    );
}

export default Checkbox;
